import Experience from "./components/Experience";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Contact from "./components/Contact";



function App() {
  return (
    <div className="bg-gray-900 text-white">
          <Navbar />
      <div className="min-h-screen flex flex-col items-center justify-center px-4 text-center">
        <h1 className="text-4xl md:text-6xl font-bold mb-4">Fatima Khan</h1>
        <p className="text-xl md:text-2xl mb-2">Web Developer • Salesforce CRM • Data Analyst</p>
        <p className="text-md text-gray-300">📍 Dubai | 📧 khanfatimamohamed@gmail.com</p>
        <a
          href="https://www.linkedin.com/in/fatima-khan-6343b7223"
          className="mt-6 inline-block px-6 py-2 bg-blue-600 rounded hover:bg-blue-700 transition"
          target="_blank" rel="noreferrer"
        >
          View My LinkedIn
        </a>
      </div> 
      <Experience />
      <Projects />
      <Skills />
      <Contact />
    </div>
  );
}

export default App;
